import React from "react";
import {InternalDirectoryRepository} from "../../../repository";
import {InternalDirectory} from "../../../model";
import {EntityReadTemplate} from "../../../component/template/EntityReadTemplate";

export const ReadInternalDirectory = () => {

    return (
        <EntityReadTemplate<InternalDirectory>
            repository={new InternalDirectoryRepository()}
            title={{
                page: `Document`,
                schema: `$0`,
                params: [`name`]
            }}
            attributes={[
                { label: `Nom`, key: 'name' },
                { label: `Permission`, key: 'permission' },
                { label: `Nombre de fichiers`, key: 'numberOfFiles' },
            ]}
        />
    )
}